import { render, staticRenderFns } from "./RuleCards.vue?vue&type=template&id=06477afa&"
import script from "./RuleCards.vue?vue&type=script&lang=js&"
export * from "./RuleCards.vue?vue&type=script&lang=js&"
import style0 from "./RuleCards.vue?vue&type=style&index=0&id=06477afa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports